if (!global.test) {
    var swal = require('bootstrap-sweetalert');
    swal.setDefaults({ animation: false });
}

var constants = require('./constants');
var availableLocales = constants.serverConstants.availableLocales;
var filekeyHelpers = require('./filekey-helpers');

var notificationFormController = {
    init: function () {
        var self = this;
        self.availableLocales = availableLocales;
        return notificationFormModel.init().then(function() {
            notificationFormView.init();
        });
    },
    getNotificationAlertForModel(bucket, model) {
        return notificationFormModel.getNotificationAlertForModel(bucket, model);
    },
    getNotificationAlertForPrefix(bucket, prefix) {
        return notificationFormModel.getNotificationAlertForPrefix(bucket, prefix);
    },
    setNotificationAlert(bucket, prefix, alert) {
        console.log('submitted!', bucket, prefix, alert.titleLocKey, alert.locKey);
        notificationFormModel.setNotificationAlert(bucket, prefix, alert);
    }
}

var notificationFormModel = {
    notificationAlertKey: 'notification-alert',
    init: function () {
        var self = this;
        self.notificationAlertObj = {};
        if ("s3" in window) {
            return Promise.resolve();
        }
        return new Promise(function (resolve, reject) {
            document.addEventListener('s3Ready', function () {
                resolve();
            });
        });
    },
    prefixForModel: function(model) {
        var re = /([A-Z0-9]+-)+(?:[A-Z0-9])+/g;
        var matches = model.match(re);
        return (matches != null && matches.length == 1) ? matches[0] : null;
    },
    getPublishedModelPrefixes: function () {
        var self = this;
        var modelsItem = localStorage.getItem('models');
        if (modelsItem) {
            var modelObjArray = JSON.parse(modelsItem);
            var prefixMap = {};
            modelObjArray.forEach(function(modelObj){
                var prefix = self.prefixForModel(modelObj.model);
                if (prefix != null) {
                    prefixMap[prefix] = modelObj.bucket;
                }
            });
            return prefixMap;
        } else {
            return {};
        }
    },
    getNotificationAlertForModel(bucket, model) {
        var self = this;
        var prefix = self.prefixForModel(model);
        return self.getNotificationAlertForPrefix(bucket, prefix)
    },
    getNotificationAlertForPrefix(bucket, prefix) {
        var self = this;
        if (self.notificationAlertObj[prefix] != null) {
            return Promise.resolve(self.notificationAlertObj[prefix]);
        }
        return window.s3.getObject({
            Bucket: bucket,
            Key: filekeyHelpers.generateNotificationFileKey(prefix, 'en')
        }).promise().then(function(res) {
            var alert = JSON.parse(res.Body);
            if (alert == null || 'locKey' in alert === false || 'titleLocKey' in alert === false) {
                return {titleLocKey: 'Rayz Update Available', locKey: 'Tap to update your Rayz now'};
            } else {
                self.notificationAlertObj[prefix] = alert
                return alert
            }
        }).catch(function(error){
            return {titleLocKey: 'Rayz Update Available', locKey: 'Tap to update your Rayz now'};
        });
    },
    setNotificationAlert(bucket, prefix, alert) {
        var self = this;
        self.notificationAlertObj[prefix] = alert;
        var updateParams = {
            Bucket: bucket,
            Key: filekeyHelpers.generateNotificationFileKey(prefix, 'en'),
            Body: JSON.stringify(alert),
            ContentType: 'application/json'
        };
        return window.s3.putObject(updateParams).promise();
    }
}

var notificationFormView = {
    init: function () {
        this.editNotificationFormEl = document.querySelector('#edit-notification-form');
        this.modelPrefixSelectEl = document.querySelector('#model-prefix-select');
        this.notificationTitleEl = document.querySelector('#alert-title-loc-key');
        this.notificationBodyEl = document.querySelector('#alert-loc-key');
        this.initSubmitHandler();
        this.renderPrefixSelect();
        this.renderNotificationAlert();
        this.initModelPrefixSelectHandler();
    },
    initSubmitHandler: function (e) {
        var self = this;
        this.editNotificationFormEl.addEventListener('submit', function (e) {
            e.preventDefault();
            var index = self.modelPrefixSelectEl.selectedIndex;
            var prefix = self.modelPrefixSelectEl.options[index].text;
            var bucket = self.modelPrefixSelectEl.options[index].value;
            var alert = {titleLocKey: self.notificationTitleEl.value, locKey: self.notificationBodyEl.value};
            notificationFormController.setNotificationAlert(bucket, prefix, alert);
        });
    },
    initModelPrefixSelectHandler: function (e) {
        var self = this;
        this.modelPrefixSelectEl.onchange = function () {
            self.renderNotificationAlert();
        }
    },
    renderPrefixSelect: function () {
        var self = this;
        var prefixMap = notificationFormModel.getPublishedModelPrefixes();
        this.modelPrefixSelectEl.options.length = 0;
        Object.keys(prefixMap).forEach(function (prefix, index) {
            self.modelPrefixSelectEl.options[index] = new Option(prefix, prefixMap[prefix], false, false);
        });
    },
    renderNotificationAlert: function() {
        var self = this;
        var index = self.modelPrefixSelectEl.selectedIndex;
        var prefix = self.modelPrefixSelectEl["options"][index].text;
        var bucket = self.modelPrefixSelectEl.value;
        notificationFormController.getNotificationAlertForPrefix(bucket, prefix).then(function(alert) {
            self.notificationTitleEl.value = alert.titleLocKey;
            self.notificationBodyEl.value = alert.locKey;
        });
    }
}

module.exports = {notificationFormController: notificationFormController, notificationFormModel: notificationFormModel};